import * as types from './types';
import { BookingService } from '../../services/booking-service';
import { requestCancellationErrorHandler, REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { HttpLib } from '../../../../services/http/http-lib';
import { HttpClient, createHttpGetOptions } from '../../../../services/http/http-client';
import { validateResponse } from '../../../../services/http/response-validator';
import { SET_MAIN_NAV_ACTIVE } from '../../../../store/app/types';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import { setMainNavInactive } from '../../../../store/app/mutations';
import router from '../../../../router';

let getContactsFormPromoterTokenSource = null;
const NavTabModule = getNavTabModule(types.PromoterDetails, 'promoterDetails');

export const bookingPromotersActions = {
    //GET booking -> Promoters
    async [types.GET_BOOKING_PROMOTERS]({ commit, state }, start) {
        const res = await BookingService.getBookingPromoters(start);

        if (start) {
            commit(types.SET_MORE_BOOKING_PROMOTERS, res.data.promoters);
        } else {
            commit(types.SET_BOOKING_PROMOTERS, res.data.promoters);
            commit(types.SET_CLIENT_DISPLAY_NAME, res.data.client_display_name);
        }

        state.promoters_list_start_from = start || 0;
    },

    async [types.GET_CONTACTS_FOR_PROMOTER]({ commit, state }, start) {
        let source, cancelToken;

        if (getContactsFormPromoterTokenSource) {
            getContactsFormPromoterTokenSource.cancel(REQUEST_CANCELLED);
        }

        getContactsFormPromoterTokenSource = HttpLib.CancelToken.source();
        cancelToken = getContactsFormPromoterTokenSource.token;
        
        const res = await BookingService.getContactsForPromoter(start,
            createHttpGetOptions({
                cancelToken: cancelToken
            }));

        if (start) {
            commit(types.SET_MORE_CONTACTS_FOR_PROMOTER, res.data);
        } else {
            commit(types.SET_CONTACTS_FOR_PROMOTER, res.data);
        }

        state.add_promoter_contact_list_start_from = start || 0;
    },

    async[types.DELETE_BOOKING_PROMOTER]({ commit, dispatch, state }, promoterID) {
        let itemsAfterDeleted = state.bookingPromoters.filter(
            row => row.promoter_id != promoterID
        );
        commit(types.SET_BOOKING_PROMOTERS, itemsAfterDeleted);

        const deleted = await BookingService.deleteBookingPromoter(promoterID);
        // dispatch(types.GET_BOOKING_PROMOTERS, {});
    },

    async[types.SET_BOOKING_PROMOTER_SELECTED]({ dispatch, commit, getters }, { flag, promoterID }) {
        commit(SET_MAIN_NAV_ACTIVE, !flag, { root: true });

        if (flag) {
            commit(types.SET_IS_SELECTED_PROMOTER_LOADING, true);

            dispatch(types.GET_BOOKING_PROMOTER_TAB_OVERVIEW, promoterID);
            dispatch(types.GET_BOOKING_PROMOTER_TAB_BOOKINGS, promoterID);
            dispatch(types.GET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO, promoterID);

            // commit(types.SET_IS_SELECTED_PROMOTER_LOADING, false);
        }
    },

    async[types.GET_BOOKING_PROMOTER_TAB_OVERVIEW]({ commit, state }, promoterID) {
        BookingService.getBookingPromoterTab('overview', promoterID).then(res => {
            commit(types.SET_BOOKING_PROMOTER_TAB_OVERVIEW, res.data);
        })
            .catch(requestCancellationErrorHandler);
    },

    async[types.GET_BOOKING_PROMOTER_TAB_BOOKINGS]({ commit, state }, promoterID) {
        BookingService.getBookingPromoterTab('bookings', promoterID).then(res => {
            commit(types.SET_BOOKING_PROMOTER_TAB_BOOKINGS, res.data);
        })
            .catch(requestCancellationErrorHandler);
    },

    async[types.GET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO]({ commit, state }, promoterID) {
        BookingService.getBookingPromoterTab('additional_info', promoterID).then(res => {
            commit(types.SET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO, res.data);
            commit(types.SET_IS_SELECTED_PROMOTER_LOADING, false);
        })
            .catch(requestCancellationErrorHandler);
    },

    async[types.UPDATE_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES]({ commit }, { files }) {
        commit(types.SET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES, files);
    },
    ...NavTabModule.implementActions(
        'promoter_id',
        'promoters/promoter_id/tab',
        'promoters',
        () => router,
        'booking',
        (value, key) => {
            const { promoter: { company_name, first_name, last_name } } = value;
            const title = company_name ? company_name : `${first_name} ${last_name}`;
            return {
                title: company_name || first_name || last_name ? title : key,
                full_title: company_name || first_name || last_name ? title : key
            }
        }
    ),

    // Show Sidewindow
    async [types.PromoterDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);

        let { flag, promoter, reload } = payload;

        flag = typeof flag === "boolean" ? flag : true;

        setMainNavInactive(commit, flag);

        const primaryKey = "promoter_id";
        const itemName = "promoter";
        const item = payload[itemName];

        if (!item) {
            return;
        }

        const primaryKeyValue = item[primaryKey];
        const detailsGetterKey = "promoterDetails";
        const DetailsAction = types.ArtistDetails;

        // Check Reload and prexisting Item Logic
        if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
            return;
        }

        NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
            return {
                [itemName]: item,
                loading: true
            };
        });

        // HTTP Req
        let detailsData = await HttpClient.mergeRequests([
            BookingService.getBookingPromoterTab('overview', primaryKeyValue),
            BookingService.getBookingPromoterTab('bookings', primaryKeyValue),
            BookingService.getBookingPromoterTab('additional_info', primaryKeyValue)
        ]);

        // console.log('promoterDetais:mdsir', detailsData);

        NavTabHelper.setSingleNavTabDetails(
            primaryKeyValue,
            (detailsDict, promoter) => {
                return {
                    ...promoter,
                    ...detailsData,
                    loading: false,
                };
            }
        );
    },

    async [types.PromoterContact.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);

        const { name, value, promoter_id, contactID } = payload;

        NavTabHelper.updateSingleNavTabDetails(promoter_id, promoterDetailsObj => {
            return {
                contact: {
                    ...promoterDetailsObj.contact,
                    [name]: value
                }
            };
        });

        if (name == "vat_no") {
            const ucvat = await BookingService.updateContactVatNo(contactID, value);
            NavTabHelper.updateSingleNavTabDetails(promoter_id, promoterDetailsObj => {
                return {
                    contact: {
                        ...promoterDetailsObj.contact,
                        vatIdValidityLoading: true
                    }
                };
            });

            const res = await BookingService.checkContactVatIdUpdateFlag(contactID, value);
            NavTabHelper.updateSingleNavTabDetails(promoter_id, promoterDetailsObj => {
                return {
                    contact: {
                        ...promoterDetailsObj.contact,
                        vatIdValidityLoading: false
                    },
                    check_vat_id: res.data.valid
                };
            });

        } else {
            const modifyContact = await BookingService.modify_contacts(contactID, name, value);
        }
    },

    async [types.PromoterCustomFields.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);

        const { custom_data_id, value, promoter_id } = payload;

        NavTabHelper.updateSingleNavTabDetails(promoter_id, promoterDetailsObj => {
            const fields = promoterDetailsObj.fields.map(r => {
                if (custom_data_id == r.custom_data_id) {
                    return { ...r, data: value }
                }
                return r;
            });

            return {
                fields
            };
        });

        HttpClient.modify(
            "custom_data_id",
            custom_data_id,
            "data",
            value,
            "custom_data"
        );

    },

    async [types.PromoterRelatedContacts.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);

        const { item, promoter_id } = payload;

        NavTabHelper.updateSingleNavTabDetails(promoter_id, promoterDetailsObj => {
            const contact_relations = promoterDetailsObj.contact_relations.filter(
                e => e.contact_relation_id != item.contact_relation_id
            );

            return {
                contact_relations
            };
        });

        BookingService.deleteContactRelation({
            contactRelationId: item.contact_relation_id
        });
    },

    async [types.PromoterRelatedFiles.SET.ALL]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);

        const { files, promoter_id } = payload;

        NavTabHelper.updateSingleNavTabDetails(promoter_id, promoterDetailsObj => {
            return {
                files
            };
        });
    }

};